import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Table,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  Alert,
} from "reactstrap";
import {
  getHolidays,
  addHoliday,
  deleteHoliday,
} from "../../Api/ApiUrlConst";

interface Holiday {
  id: number;
  date: string;
  name: string;
}

const HolidayManagement: React.FC = () => {
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const [year, setYear] = useState<number>(new Date().getFullYear());
  const [date, setDate] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    loadHolidays();
  }, [year]);

  const loadHolidays = async () => {
    try {
      const res = await getHolidays(year);
      setHolidays(res.data);
    } catch {
      setError("Failed to load holidays");
    }
  };

  const handleAdd = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      await addHoliday({ date, name });
      setSuccess("Holiday added successfully");
      setDate("");
      setName("");
      loadHolidays();
    } catch (err: any) {
      setError(err.response?.data || "Failed to add holiday");
    }
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm("Delete this holiday?")) return;

    await deleteHoliday(id);
    loadHolidays();
  };

  return (
    <div className="container mt-4">
      <Card>
        <CardBody>
          <CardTitle tag="h4">Holiday Management</CardTitle>

          {error && <Alert color="danger">{error}</Alert>}
          {success && <Alert color="success">{success}</Alert>}

          <Form onSubmit={handleAdd} className="mb-4">
            <Row>
              <Col md="3">
                <FormGroup>
                  <Label>Date</Label>
                  <Input
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md="5">
                <FormGroup>
                  <Label>Name</Label>
                  <Input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md="2" className="d-flex align-items-end">
                <Button color="primary" type="submit">
                  Add
                </Button>
              </Col>
              <Col md="2">
                <FormGroup>
                  <Label>Year</Label>
                  <Input
                    type="number"
                    value={year}
                    onChange={(e) => setYear(Number(e.target.value))}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Form>

          <Table bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Date</th>
                <th>Name</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {holidays.map((h, i) => (
                <tr key={h.id}>
                  <td>{i + 1}</td>
                  <td>{h.date}</td>
                  <td>{h.name}</td>
                  <td>
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => handleDelete(h.id)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
              {holidays.length === 0 && (
                <tr>
                  <td colSpan={4} className="text-center">
                    No holidays found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </div>
  );
};

export default HolidayManagement;
